import {
  FETCH_VOUCHER_PRODUCTS,
  FETCH_VOUCHER_BALANCE,
  FETCH_VOUCHERS,
  INITIATE_VOUCHER_PURCHASE,
  COMPLETE_VOUCHER_PURCHASE,
  CLEAR_VOUCHER_ERRORS,
  SET_SELECTED_VOUCHER_PRODUCT,
} from '../actions/action_vouchers';

const initialState = Object.freeze({
  // Products
  products: [],
  productsLoading: false,
  productsError: null,
  vouchersAvailable: false,
  voucherTermsUrl: null,

  // Balance
  balance: null,
  balanceLoading: false,
  balanceError: null,

  // User's vouchers
  vouchers: [],
  vouchersLoading: false,
  vouchersError: null,

  // Purchase flow
  selectedProduct: null,
  purchaseLoading: false,
  purchaseError: null,
  checkoutUrl: null,
  sessionId: null,

  // Completion
  completionLoading: false,
  completionError: null,
  purchasedVoucher: null,
});

export default function vouchersReducer(state = initialState, action) {
  Object.freeze(state);

  switch (action.type) {
    // Pending states - redux-promise dispatches _PENDING actions for loading states
    case `${FETCH_VOUCHER_PRODUCTS}_PENDING`:
      return { ...state, productsLoading: true, productsError: null };

    case `${FETCH_VOUCHER_BALANCE}_PENDING`:
      return { ...state, balanceLoading: true, balanceError: null };

    case `${FETCH_VOUCHERS}_PENDING`:
      return { ...state, vouchersLoading: true, vouchersError: null };

    case `${INITIATE_VOUCHER_PURCHASE}_PENDING`:
      return { ...state, purchaseLoading: true, purchaseError: null };

    case `${COMPLETE_VOUCHER_PURCHASE}_PENDING`:
      return { ...state, completionLoading: true, completionError: null };

    // Fetch products - redux-promise resolves the payload directly
    case FETCH_VOUCHER_PRODUCTS:
      if (action.payload && action.payload.data) {
        return {
          ...state,
          productsLoading: false,
          products: action.payload.data.products || [],
          vouchersAvailable: action.payload.data.vouchers_available || false,
          voucherTermsUrl: action.payload.data.voucher_terms_url || null,
          productsError: null,
        };
      } else if (action.error) {
        return {
          ...state,
          productsLoading: false,
          productsError:
            action.payload?.response?.data?.error || 'Failed to load products',
        };
      }
      return state;

    // Fetch balance
    case FETCH_VOUCHER_BALANCE:
      if (action.payload && action.payload.data) {
        return {
          ...state,
          balanceLoading: false,
          balance: action.payload.data,
          balanceError: null,
        };
      } else if (action.error) {
        return {
          ...state,
          balanceLoading: false,
          balanceError:
            action.payload?.response?.data?.error || 'Failed to load balance',
        };
      }
      return state;

    // Fetch vouchers
    case FETCH_VOUCHERS:
      if (action.payload && action.payload.data) {
        return {
          ...state,
          vouchersLoading: false,
          vouchers: action.payload.data.vouchers || [],
          balance: action.payload.data.balance || state.balance,
          vouchersError: null,
        };
      } else if (action.error) {
        return {
          ...state,
          vouchersLoading: false,
          vouchersError:
            action.payload?.response?.data?.error || 'Failed to load vouchers',
        };
      }
      return state;

    // Initiate purchase
    case INITIATE_VOUCHER_PURCHASE:
      if (action.payload && action.payload.data) {
        return {
          ...state,
          purchaseLoading: false,
          checkoutUrl: action.payload.data.checkout_url,
          sessionId: action.payload.data.session_id,
          purchaseError: null,
        };
      } else if (action.error) {
        return {
          ...state,
          purchaseLoading: false,
          purchaseError:
            action.payload?.response?.data?.error ||
            'Failed to initiate purchase',
        };
      }
      return state;

    // Complete purchase
    case COMPLETE_VOUCHER_PURCHASE:
      if (action.payload && action.payload.data) {
        return {
          ...state,
          completionLoading: false,
          purchasedVoucher: action.payload.data.voucher,
          completionError: null,
          // Clear checkout state
          checkoutUrl: null,
          sessionId: null,
          selectedProduct: null,
        };
      } else if (action.error) {
        return {
          ...state,
          completionLoading: false,
          completionError:
            action.payload?.response?.data?.error ||
            'Failed to complete purchase',
        };
      }
      return state;

    // Clear errors
    case CLEAR_VOUCHER_ERRORS:
      return {
        ...state,
        productsError: null,
        balanceError: null,
        vouchersError: null,
        purchaseError: null,
        completionError: null,
      };

    // Set selected product
    case SET_SELECTED_VOUCHER_PRODUCT:
      return {
        ...state,
        selectedProduct: action.payload,
      };

    default:
      return state;
  }
}
